import axios from 'axios';
import logoutCleanup from './logout-cleanup';

export const API_URL = import.meta.env.VITE_APP_API_URL;
export const API_ADDRESS_URL = import.meta.env.VITE_APP_API_ADDRESS_URL;
export const RETROFIT_API_URL = import.meta.env.VITE_APP_RETROFIT_API_URL;
export const FILE_API_URL = import.meta.env.VITE_APP_FILE_API_URL;

export const HTTP = axios.create({
  baseURL: API_URL,
});
HTTP.defaults.withCredentials = true;

export const HTTP_ADDRESS = axios.create({
  baseURL: API_ADDRESS_URL,
});
HTTP_ADDRESS.defaults.withCredentials = true;

export const HTTP_RETROFIT = axios.create({
  baseURL: RETROFIT_API_URL,
});
HTTP_RETROFIT.defaults.withCredentials = true;

export const HTTP_FILE = axios.create({
  baseURL: FILE_API_URL,
});
HTTP_FILE.defaults.withCredentials = true;

export const setAuthLocalStorage = function setAuthLocalStorage(response) {
  if (response.data.model.accessToken) {
    localStorage.setItem('account', JSON.stringify(response.data.model));
  }
};

export const getAccountFromLocalStorage = function getAccountFromLocalStorage() {
  return JSON.parse(localStorage.getItem('account'));
};

export const authHeader = function authHeader() {
  const account = getAccountFromLocalStorage();
  if (account) {
    return { Authorization: `Bearer ${account.accessToken}` };
  }
  return {};
};

function onError(error) {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest.retry) {
    originalRequest.retry = true;

    if (!getAccountFromLocalStorage()) {
      logoutCleanup();
      return Promise.reject(new Error('Session has expired - log in is required'));
    }

    const refreshRequest = {
      refreshToken: getAccountFromLocalStorage().refreshToken,
      username: getAccountFromLocalStorage().accountName,
    };

    return axios
      .post(`${API_URL}auth/refresh`, refreshRequest, {
        withCredentials: true,
        headers: authHeader(),
      })
      .then((resp) => {
        if (resp.status === 200) {
          setAuthLocalStorage(resp);

          originalRequest.headers.Authorization = `Bearer ${
            getAccountFromLocalStorage().accessToken
          }`;
          return axios(originalRequest);
        }

        logoutCleanup();
        return Promise.reject(new Error('Refresh was not successful - log in is required'));
      })
      .catch(() => {
        logoutCleanup();
        return Promise.reject(new Error('Failed to refresh - log in is required'));
      });
  }
  if (error.response.status === 422) {
    if (error.response.data.reasons) {
      const reasons = error.response.data.reasons.map((x) => `${x.field} ${x.reason}`).join(', ');
      return Promise.reject(reasons);
    }
    if (error.response.data.message) {
      return Promise.reject(error.response.data.message);
    }
  }
  return Promise.reject(error);
}

HTTP.interceptors.response.use((response) => {
  return response;
}, onError);

HTTP_ADDRESS.interceptors.response.use((response) => {
  return response;
}, onError);

HTTP_RETROFIT.interceptors.response.use((response) => {
  return response;
}, onError);

HTTP_FILE.interceptors.response.use((response) => {
  return response;
}, onError);
